export default __webpack_public_path__ + "static/construction-debris-removal-icon-0049fc95d3eb86a7d5e8ae1761e3caca.png";